import { Component, OnInit, ViewChild } from '@angular/core';
import { CallbackService } from 'src/app/services/callback/callback.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getFirebaseBackend } from 'src/app/authUtils';
import { UserService } from 'src/app/services/user/user.service';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/services/loader/loader.service';

@Component({
	selector: 'app-callback-list',
	templateUrl: './callback.component.html',
	styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
	callbacks: any[] = [];
	selectedCampaign!: number;
	user: any;
	campaignId!: number;
	alias!: string;
	loadingCallbacks: boolean = false;
	selectedCallback: any;
	callbackDate: any;
	activeTab: string;
	selectedReschedule: any;
	reschedules: any[] = [];
	campaignName: string = '';
	isLoading = false;
	modalTab = 1;

	@ViewChild('editRescheduleModal') editRescheduleModal: any;

	constructor(private callbackSrv: CallbackService, private route: ActivatedRoute, private userSrv: UserService, private prospectsSrv: ProspectsService, private router: Router, private campaignsSrv: CampaignsService, private modalSrv: NgbModal, private campaignSrv: CampaignsService, private loaderSrv: LoaderService) {}

	ngOnInit(): void {
		this.loaderSrv.loading$.subscribe((loading) => {
			this.isLoading = loading;
		});
		this.activeTab = 'callbacks';
		this.userSrv.saveAction('Callbacks View');

		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		if (!this.user || !this.user.IdUser) {
			console.error('No user logged in or invalid UserId');
			return;
		}
		this.route.paramMap.subscribe((params) => {
			const campaignParam = params.get('campaign_id');
			this.alias = params.get('alias') || '';

			if (!campaignParam) {
				console.warn('No campaignId received in the route');
				return;
			}

			const campaignNum = Number(campaignParam);
			if (isNaN(campaignNum)) {
				console.error('campaignId is not a valid number:', campaignParam);
				return;
			}

			this.campaignId = campaignNum;
			this.selectedCampaign = campaignNum;

			this.route.queryParamMap.subscribe((queryParams) => {
				const tab = queryParams.get('tab');
				if (tab === 'reschedules') {
					this.activeTab = 'reschedules';
					this.loadReschedules();
				} else {
					this.activeTab = 'callbacks';
					this.loadCallbacks();
				}
			});
		});
	}

	goBack(): void {
		this.router.navigate(['/']);
	}

	loadCallbacks() {
		this.loaderSrv.show();
		if (!this.selectedCampaign || !this.user) return;

		this.loadingCallbacks = true;
		const userId = this.user.IdUser;

		this.callbackSrv.getCallbacks(userId, this.selectedCampaign).subscribe(
			(res) => {
				this.loaderSrv.hide();
				if (res.success) {
					this.callbacks = res.body;
				} else {
					this.callbacks = [];
					Swal.fire('Notice', 'No callbacks found', 'info');
				}
				this.loadingCallbacks = false;
			},
			(err) => {
				this.loaderSrv.hide();
				this.loadingCallbacks = false;
				Swal.fire('Error', 'An error occurred while loading callbacks', 'error');
			}
		);
	}

	onCallbackRowClick(event: any) {
		if (event.type === 'dblclick' && event.row) {
			if ((event.event.target as HTMLElement).closest('button')) {
				return;
			}
			const primaryPhone = event.row.primary_phone || '';
			const campaignId = this.campaignId;
			const alias = this.alias;
			if (!campaignId) {
				Swal.fire('Error', 'A valid campaignId is not available', 'error');
				return;
			}
			this.router.navigate(['/prospect-info', campaignId, alias, primaryPhone], { queryParams: { from: 'callback' } });
		}
	}
	formatPhone(phone: string): string {
		if (!phone) return '';

		const digits = phone.replace(/\D/g, '');
		if (digits.length === 10) {
			return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
		}

		return phone;
	}

	openModal(content: any, row: any) {
		this.selectedCallback = row;
		this.callbackDate = row.callback_date ? row.callback_date : '';
		this.modalSrv.open(content, { centered: true });
	}

	saveCallback() {
		if (!this.selectedCallback) return;
		this.selectedCallback.callback_date = this.callbackDate;
		this.callbackSrv.updateCallback(this.selectedCallback).subscribe({
			next: (res) => {
				Swal.fire('Saved', 'The callback was updated successfully', 'success');
			},
			error: (err) => {
				Swal.fire('Error', 'The callback could not be updated', 'error');
				console.error(err);
			},
		});
	}

	deleteCallback() {
		if (!this.selectedCallback) return;

		Swal.fire({
			title: 'Are you sure?',
			text: 'This callback will be deleted',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.isConfirmed) {
				this.loadingCallbacks = true;

				this.callbackSrv.deleteCallback(this.selectedCallback.callback_id).subscribe({
					next: () => {
						Swal.fire('Deleted', 'The callback was deleted successfully', 'success');

						this.modalSrv.dismissAll();
						this.selectedCallback = null;

						this.loadCallbacks();
					},
					error: (err) => {
						Swal.fire('Error', 'The callback could not be deleted', 'error');
						console.error(err);
						this.loadingCallbacks = false;
					},
				});
			}
		});
	}
	loadReschedules() {
		this.loaderSrv.show();
		this.activeTab = 'reschedules';
		if (!this.selectedCampaign || !this.user) return;

		const userId = this.user.IdUser;

		this.callbackSrv.getReschedules(this.campaignId).subscribe({
			next: (data) => {
				this.loaderSrv.hide();
				this.reschedules = data?.body || [];
			},
			error: (err) => {
				this.loaderSrv.hide();
				console.error('❌ Error al obtener reschedules:', err);
			},
		});
	}

	getCampaignName(campaignId: string) {
		if (!campaignId || campaignId === '0') return;

		this.campaignSrv.getCampaignInfoCalendar(campaignId).subscribe({
			next: (res: any) => {
				if (res && res.success && res.body) {
					this.campaignName = res.body.name || 'Unknown';
				} else {
					console.warn('No se encontró información de la campaña.');
				}
			},
			error: (err) => {
				console.error('Error al obtener información de campaña:', err);
			},
		});
	}

	onActivate(event: any): void {
		if (event.type === 'click') {
			this.selectedReschedule = event.row;
			this.openEditModal();
		}
	}

	openEditModal(): void {
		this.modalTab = 1;
		this.modalSrv.open(this.editRescheduleModal, {
			size: 'xl',
			scrollable: true,
			centered: true,
			backdrop: 'static',
		});
	}

	saveReschedule(modal: any): void {
		this.callbackSrv.updateReschedule(this.selectedReschedule).subscribe({
			next: () => {
				modal.close();
				Swal.fire('Success', 'Appointment date updated successfully', 'success');
			},
			error: () => {
				Swal.fire('Error', 'Error updating appointment date', 'error');
			},
		});
	}
}
